import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { encryptURLParam, decryptURLParam } from "../../Common/Axios/encrypt";

const Redeemable = ({ onRedeemable, setPageNumber, checkedRedeemable }) => {
  const translation = getTranslationData();
  const navigate = useNavigate();
  const location = useLocation();

  const OPTIONS = [
    { key: "online", label: translation?.online || "Online" },
    { key: "offline", label: translation?.offline || "In-Store" },
    { key: "both", label: translation?.both || "Both" },
  ];

  const [selected, setSelected] = useState([]); // array of string tokens

  useEffect(() => {
    if (checkedRedeemable) {
      const arr = String(checkedRedeemable).split(",").map(s => s.trim().toLowerCase()).filter(Boolean);
      setSelected(arr);
    } else {
      const params = new URLSearchParams(location.search);
      const enc = params.get("redemptionType"); // <-- changed param name
      if (enc) {
        const dec = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false' ? enc : decryptURLParam(enc);
        const arr = String(dec).split(",").map(s => s.trim().toLowerCase()).filter(Boolean);
        setSelected(arr);
      } else {
        setSelected([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedRedeemable, location.search]);

  const setRedeemableParam = (arr) => {
    const params = new URLSearchParams(location.search);
    if (arr && arr.length) {
      const token = arr.join(",");
      const finalVal = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false' ? token : encryptURLParam(token);
      params.set("redemptionType", finalVal); // <-- changed param name
      if (typeof onRedeemable === "function") onRedeemable(token);
    } else {
      params.delete("redemptionType");
      if (typeof onRedeemable === "function") onRedeemable(null);
    }
    navigate(`${location.pathname}?${params.toString()}`, { replace: false });
  };

  const toggle = (key) => {
    const next = selected.includes(key) ? selected.filter(k => k !== key) : [...selected, key];
    const ordered = OPTIONS.map(o => o.key).filter(k => next.includes(k));
    setSelected(ordered);
    if (typeof setPageNumber === "function") setPageNumber(1);
    setRedeemableParam(ordered);
  };

  return (
    <div className="sidefilboxlist">
      <div className="filterdrpbtn">
        <span>{translation?.redeemable || "Redeemable"}</span>
      </div>
      <div id="categorufil2" className="filterinner collapse show" data-parent="#otherfilter">
        <div className="checklistfilter">
          <div className="filktermaxht">
            <fieldset className="form-group1">
              {OPTIONS.map(opt => (
                <div key={opt.key} className="rangeSlider d-flex filter-container">
                  <label className="checkbox-container">
                    <input
                      id={opt.label}
                      type="checkbox"
                      className="pointer filter_category_checkbox"
                      checked={selected.includes(opt.key)}
                      onChange={() => toggle(opt.key)}
                    />
                    <label className="pointer" htmlFor={opt.label}>{opt.label}</label>
                  </label>
                </div>
              ))}
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Redeemable;
